(() => {
  const prepare = anchor => {
    if (!anchor || anchor.hasAttribute('download') || anchor.getAttribute('href')?.startsWith('#') || anchor.closest('.kom-seo-navigation')) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname)) return;
    if (url.searchParams.has('filter.v.availability')) return;
    url.searchParams.set('filter.v.availability', '1');
    anchor.href = url.href;
  };
  document.querySelectorAll('a[href]').forEach(prepare);
  for (const event of ['pointerover', 'pointerdown', 'focusin', 'click']) {
    document.addEventListener(event, e => prepare(e.target.closest?.('a[href]')), true);
  }
})();
